import { RestAPI } from './rest-api.service';
import { BASE_URL } from '../types/constants';
import { HomeHighlight } from '../types/home.types';

const api = new RestAPI();

/**
 * Public highlights feed.
 * Endpoint: GET /v1/highlights
 */
export const fetchHighlights = async (): Promise<HomeHighlight[]> => {
    const url = `${BASE_URL}/v1/highlights`;
    return api.get(url);
};
